var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "Create new availability",
            label: _vm.submitLoading ? "Creating" : "Create",
            submitLoading: _vm.submitLoading,
            disabled: _vm.isDisabledSubmit
          },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onSubmit
          }
        },
        [
          _c(
            "div",
            {
              class: {
                "overflow-y-auto":
                  _vm.conflictedByRoom.length || _vm.conflictedByUser.length
              },
              style: { width: "40rem", maxHeight: "calc(100vh - 14rem)" }
            },
            [
              _vm.modalLoading
                ? _c("div", { staticClass: "grid place-items-center h-100" }, [
                    _c("div", { staticClass: "blum-loader" })
                  ])
                : _c("div", { staticClass: "flex flex-col gap-4 px-8" }, [
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "user", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _vm.kindInput === "for_therapist"
                          ? _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlSelectBox", {
                                  staticClass: "w-96",
                                  attrs: {
                                    search: "",
                                    placeholder: "Select therapist",
                                    options: _vm.defaultTherapistOptions,
                                    fetchProperty: {
                                      url:
                                        "/api/v1/users?sort=name_asc&status=active&query=",
                                      dataKey: "users",
                                      countKey: "total_users",
                                      optionKeys: { value: "id", label: "name" }
                                    },
                                    disabled: _vm.selectedTherapist !== null
                                  },
                                  on: {
                                    change: function($event) {
                                      _vm.therapistInput = $event
                                    }
                                  },
                                  model: {
                                    value: _vm.therapistInput,
                                    callback: function($$v) {
                                      _vm.therapistInput = $$v
                                    },
                                    expression: "therapistInput"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  attrs: {
                                    type: "plain",
                                    label: "Set as open room",
                                    disabled: _vm.selectedTherapist !== null
                                  },
                                  on: {
                                    clicked: function($event) {
                                      _vm.kindInput = "open_room"
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.kindInput === "open_room"
                          ? _c(
                              "div",
                              { staticClass: "flex items-center gap-2" },
                              [
                                _c("BlSelectBox", {
                                  key: "open-room-placeholder",
                                  staticClass: "w-112",
                                  attrs: {
                                    options: [
                                      {
                                        value: 0,
                                        label:
                                          "Open room - available to everyone"
                                      }
                                    ],
                                    disabled: ""
                                  },
                                  model: {
                                    value: _vm.openRoomInput,
                                    callback: function($$v) {
                                      _vm.openRoomInput = $$v
                                    },
                                    expression: "openRoomInput"
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlInputButton", {
                                  attrs: { type: "plain", label: "Remove" },
                                  on: {
                                    clicked: function($event) {
                                      _vm.kindInput = "for_therapist"
                                    }
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "calendar-blank", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlInputDate", {
                          staticClass: "flex-grow",
                          attrs: { input: _vm.startDateInput },
                          on: { changed: _vm.inputHandler }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "clock-outline", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          staticClass: "w-64",
                          attrs: {
                            search: "",
                            placeholder: "From",
                            options: _vm.startTimeOptions
                          },
                          on: {
                            change: function($event) {
                              _vm.startTimeInput = $event
                            }
                          },
                          model: {
                            value: _vm.startTimeInput,
                            callback: function($$v) {
                              _vm.startTimeInput = $$v
                            },
                            expression: "startTimeInput"
                          }
                        }),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "arrow-right", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          key: "end-time-" + _vm.startTimeInput,
                          staticClass: "w-62",
                          attrs: {
                            search: "",
                            placeholder: "To",
                            options: _vm.endTimeOptions
                          },
                          on: {
                            change: function($event) {
                              _vm.endTimeInput = $event
                            }
                          },
                          model: {
                            value: _vm.endTimeInput,
                            callback: function($$v) {
                              _vm.endTimeInput = $$v
                            },
                            expression: "endTimeInput"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.enableBranch
                      ? _c(
                          "div",
                          { staticClass: "flex items-center gap-2" },
                          [
                            _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "location", color: "slate-6" }
                            }),
                            _vm._v(" "),
                            _c("BlSelectBox", {
                              staticClass: "w-136",
                              attrs: {
                                type: "branch",
                                search: "",
                                placeholder: "Select branch",
                                options: _vm.defaultBranchOptions,
                                fetchProperty: {
                                  url: "/api/v1/branches?sort=name_asc&query=",
                                  dataKey: "branches",
                                  countKey: "total_count",
                                  optionKeys: {
                                    value: "id",
                                    label: "name",
                                    color: "color",
                                    backgroundColor: "background_color"
                                  }
                                },
                                disabled:
                                  !_vm.endTimeInput || _vm.selectedRoom !== null
                              },
                              on: {
                                change: function($event) {
                                  _vm.branchInput = $event
                                }
                              },
                              model: {
                                value: _vm.branchInput,
                                callback: function($$v) {
                                  _vm.branchInput = $$v
                                },
                                expression: "branchInput"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "door", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          key: "room-" + _vm.branchInput,
                          staticClass: "w-136",
                          attrs: {
                            search: "",
                            placeholder: _vm.roomSelectLoading
                              ? "Loading..."
                              : "Select room",
                            options: _vm.roomOptions,
                            disabled:
                              !_vm.endTimeInput || _vm.selectedRoom !== null
                          },
                          on: {
                            change: function($event) {
                              _vm.roomInput = $event
                            }
                          },
                          model: {
                            value: _vm.roomInput,
                            callback: function($$v) {
                              _vm.roomInput = $$v
                            },
                            expression: "roomInput"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "repeat", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlSelectBox", {
                          staticClass: "max-w-136",
                          attrs: {
                            options: _vm.repeatOptions,
                            disabled: !_vm.startDateInput.model
                          },
                          on: {
                            change: function($event) {
                              return _vm.onChangeRepeat($event)
                            }
                          },
                          model: {
                            value: _vm.repeatInput,
                            callback: function($$v) {
                              _vm.repeatInput = $$v
                            },
                            expression: "repeatInput"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex items-center gap-2" },
                      [
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "calendar-x", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlInputDate", {
                          staticClass: "flex-grow",
                          attrs: {
                            input: {
                              model: _vm.displayEndAfter,
                              disabled: true
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("BlIcon", {
                          staticClass: "w-6 h-6",
                          attrs: { icon: "horizontal-arrow", color: "slate-6" }
                        }),
                        _vm._v(" "),
                        _c("BlInputText", {
                          staticClass: "flex-grow",
                          attrs: {
                            input: {
                              inputType: "number",
                              model: _vm.displayOccurrences,
                              suffix: "time(s)",
                              disabled: true
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.conflictedByRoom.length || _vm.conflictedByUser.length
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "flex items-start gap-2 px-3 py-2 rounded bg-tulip-100"
                          },
                          [
                            _c("BlIcon", {
                              staticClass: "w-6 h-6",
                              attrs: { icon: "warning", color: "tulip-7" }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex flex-col w-128" },
                              [
                                _vm.conflictedByRoom.length
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-col" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("BlTextBody2", {
                                              staticClass: "text-tulip-700",
                                              attrs: {
                                                text: _vm.suffixRoomError
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.conflictedByRoom, function(
                                          date,
                                          idx
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: idx,
                                              staticClass:
                                                "flex items-center gap-2 px-2"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "w-1 h-1 rounded bg-tulip-700"
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                staticClass: "text-tulip-700",
                                                attrs: { text: date }
                                              })
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.conflictedByUser.length
                                  ? _c(
                                      "div",
                                      { staticClass: "flex flex-col" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm.conflictedByRoom.length
                                              ? _c("BlTextBody2", {
                                                  staticClass: "text-tulip-700",
                                                  attrs: {
                                                    text: "Additionally,"
                                                  }
                                                })
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c("BlTextBody2", {
                                              staticClass: "text-tulip-700",
                                              attrs: {
                                                text: _vm.suffixUserError
                                              }
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _vm._l(_vm.conflictedByUser, function(
                                          date,
                                          idx
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: idx,
                                              staticClass:
                                                "flex items-center gap-2 px-2"
                                            },
                                            [
                                              _c("div", {
                                                staticClass:
                                                  "w-1 h-1 rounded bg-tulip-700"
                                              }),
                                              _vm._v(" "),
                                              _c("BlTextBody2", {
                                                staticClass: "text-tulip-700",
                                                attrs: { text: date }
                                              })
                                            ],
                                            1
                                          )
                                        })
                                      ],
                                      2
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("BlTextBody2", {
                                  staticClass: "text-tulip-700",
                                  attrs: {
                                    text:
                                      "Please adjust the details to proceed with the availability."
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e()
                  ])
            ]
          )
        ]
      ),
      _vm._v(" "),
      _vm.repeatDetailsOpened
        ? _c("RepeatDetailsModal", {
            attrs: {
              title: "create",
              current: {
                startDateInput: _vm.startDateInput.model,
                intervalInput: _vm.intervalInput,
                repetitionTypeInput: _vm.repetitionTypeInput,
                repeatEndInput: _vm.repeatEndInput,
                daysOfWeekInput: _vm.daysOfWeekInput,
                dayOfMonthInput: _vm.dayOfMonthInput,
                weekOfMonthInput: _vm.weekOfMonthInput,
                endAfterInput: _vm.endAfterInput,
                occurrencesInput: _vm.occurrencesInput
              }
            },
            on: {
              "close-modal": function($event) {
                _vm.repeatDetailsOpened = false
              },
              "on-submit": _vm.onChangeRepeatDetails
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1310585c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1310585c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/availabilities/timeslot/NewAvailabilitiesModal.vue
// module id = null
// module chunks = 